import { Button, Col, Image, Pagination, Row } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import OfficeIcon from "../../../assets/images/icons/office.svg";
import LocationIcon from "../../../assets/images/icons/location.svg";
import CalendarIcon from "../../../assets/images/icons/calendar.svg";
import ErrorIcon from "../../../assets/images/icons/error.svg";
import toastr from "toastr";
import "./index.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { LoadingView } from "../../common";
import placementOfficer from "../../../api/placementOfficer";
import { getRequest } from "../../../api/http";
import defaultCompany from "../../../assets/images/icons/default-company.png";

export default function EmployerbyId() {
  const { empId } = useParams();
  const location = useLocation();
  const eventId = location.state?.eventId;
  const navigate = useNavigate();
  let splitUrl = window.location.pathname.split("/");
  let splitUrlValue = splitUrl[1];
  const [jobsList, setJobsList] = useState([]);
  const [loading, setloading] = useState(false);

  const [tabsKey, setTabsKey] = useState("PUBLISH");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [employerData, setEmployerData] = useState([]);
  const [jobs, setJobs] = useState([]);

  const fetchEmployer = async () => {
    try {
      // eslint-disable-next-line no-unused-vars
      setloading(true)
      const response = await getRequest(
        placementOfficer.getEmployerById(eventId, empId)
      );
      console.log("response", response);
      setEmployerData(response);
      if (response) {
        setloading(false);
      }
    } catch (e) {
      setloading(false);
      toastr.error(e.message);
    }
  };
  const fetchJobs = async () => {
    try {
      // eslint-disable-next-line no-unused-vars
      const response = await getRequest(
        placementOfficer.getEmployerjobs(eventId, empId)
      );
      console.log("response", response);
      setJobs(response.content);
      if (response) {
        setloading(false);
      }
    } catch (e) {
      setloading(false);
      toastr.error(e.message);
    }
  };
  useEffect(() => {
    fetchEmployer();
    fetchJobs();
  }, []);

  // useEffect(() => {
  //     if (jobId) {
  //         fetchJobById(jobId);
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [jobId]);

  function onChange(pageNumber) {
    setCurrentPage(pageNumber);
  }

  if (loading) return <LoadingView message="Loading..." />;
  return (
    <div className="employerlist">
      <div className="headingContainer">
        <div className="headingTitle">
          <h3>Company's Profile</h3>
        </div>
        <div className="headingButton">
          <Button onClick={() => navigate(-1)} type="primary">
            Back
          </Button>
        </div>
      </div>

      <div className="employerDetails">
        <div className="adminHome">
          <div className="profile">
            <div className="profileCard">
              <Row gutter={16}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                >
                  <div className="profileImage">
                    <div className="imageConatainer">
                      <div className="imageRow">
                        <img
                          src={employerData.profileUrl || defaultCompany}
                          alt="defaultLogo"
                          className="imageSize"
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                >
                  <div className="profileSection">
                    {employerData?.registeredAs === "COMPANY" ? (
                      <div className="ProfileTitle">
                        <h2>{employerData.companyName}</h2>
                      </div>
                    ) : null}
                    {/* <div className="ProfileFeatures">
                                        
                                            < h3 className={employerData?.isKycCompleted ? 'kycActiveStatus' : ''} > KYC - {employerData?.isKycCompleted ? 'Verified' : 'Pending'}</h3>
                                        </div> */}
                    <div className="companyProfile">
                      {employerData?.registeredAs === "COMPANY" ? (
                        <React.Fragment>
                          <div className="companyProfileHead">
                            Company Description:
                          </div>
                          <div className="companyProfileDetail textOverFlow">
                            {employerData?.companyDescription !== null || ""
                              ? employerData?.companyDescription
                              : "--"}
                          </div>
                          {/* {employerData?.gstin &&
                                                        <React.Fragment>
                                                            <div className='companyProfileHead'>
                                                                GSTIN No:
                                                            </div>
                                                            <div className='companyProfileDetail'>
                                                                {employerData?.gstin !== null || '' ? employerData?.gstin : "--"}
                                                            </div></React.Fragment>} */}
                          {/* {employerData?.pan &&
                                                        <React.Fragment>
                                                            <div className='companyProfileHead'>
                                                                PAN No:
                                                            </div>
                                                            <div className='companyProfileDetail'>
                                                                {employerData?.pan !== null || '' ? employerData?.pan : "--"}
                                                            </div></React.Fragment>} */}
                        </React.Fragment>
                      ) : null}
                      <div className="companyProfileHead">Contact Name:</div>
                      <div className="companyProfileDetail">
                        {employerData?.contactName}
                      </div>
                      <div className="companyProfileHead">Email:</div>
                      <div className="companyProfileDetail">
                        {employerData?.email}
                      </div>
                      {employerData?.registeredAs === "INDIVIDUAL" ? (
                        <React.Fragment>
                          <div className="companyProfileHead">Gender:</div>
                          <div className="companyProfileDetail">
                            {employerData?.employerGender !== null
                              ? employerData?.employerGender
                              : "--"}
                          </div>
                        </React.Fragment>
                      ) : null}
                      <div className="companyProfileHead">Phone</div>
                      <div className="companyProfileDetail">
                        {employerData?.phone !== null
                          ? employerData?.phone
                          : "--"}
                      </div>
                      <div className="companyProfileHead">Address</div>
                      <div className="companyProfileDetail textOverFlow">
                        {employerData?.address}
                      </div>
                      <div className="companyProfileHead">City</div>
                      <div className="companyProfileDetail">
                        {employerData?.city}
                      </div>
                      <div className="companyProfileHead">State</div>
                      <div className="companyProfileDetail">
                        {employerData?.state}
                      </div>
                      <div className="companyProfileHead">Pincode</div>
                      <div className="companyProfileDetail">
                        {employerData?.pincode}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <h2>JOBS POSTED</h2>
      {jobs.length === 0 ? (
        <div className="errorMsg">
          <Image src={ErrorIcon} preview={false} />
          <h4>No active Jobs</h4>
        </div>
      ) : (
        jobs?.map((job, i) => (
          <div key={i} className="jobsRow" style={{}}>
            <Link>
              <div className="jobsHead">
                <div className="jobsHeadCol">
                  <h3>
                    {job.title}
                    {
                      // <small>{job.company}</small>
                    }
                  </h3>
                  <ul>
                    <li>
                      <span>
                        <Image src={OfficeIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">Working Type</span>
                        <span className="infoNameValue">
                          {job.workingType === "WORK_FROM_OFFICE"
                            ? "Work from office"
                            : job.workingType === "WORK_FROM_HOME"
                            ? "Work from home"
                            : "Flexible"}
                        </span>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src={LocationIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">Location</span>
                        <span className="infoNameValue">
                          <span>{job.city !== null ? job.city : "-"}</span>
                        </span>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src={CalendarIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">
                          Job Submission date
                        </span>
                        <span className="infoNameValue">
                          <span>
                            {job.deadLine !== null
                              ? moment(job.deadLine).format("DD-MM-YYYY")
                              : "-"}
                          </span>
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </Link>
            <div className="jobsInfo">
              <div
                className={
                  jobs.id ? "jobsInfoCol jobsInfoColWidth" : "jobsInfoCol"
                }
              >
                {job.status === "PUBLISH" ? (
                  <ul>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "APPLIED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "applicant"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Applied
                        </span>
                        <span
                          style={
                            splitUrlValue === "applicant"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.applied}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "SHORTLISTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "shortlisted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Shortlisted
                        </span>
                        <span
                          style={
                            splitUrlValue === "shortlisted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.shortlisted}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "OFFERED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "offered"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Offered
                        </span>
                        <span
                          style={
                            splitUrlValue === "offered"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.offered}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "REJECTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Rejected
                        </span>
                        <span
                          style={
                            splitUrlValue === "rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.rejected}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "VIEWED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "view"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Viewed
                        </span>
                        <span
                          style={
                            splitUrlValue === "view"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.viewed}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "IN_REVIEW" }}
                      >
                        <span
                          style={
                            splitUrlValue === "onHold"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          On Hold
                        </span>
                        <span
                          style={
                            splitUrlValue === "onHold"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.inReview}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "OFFER_ACCEPTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "offer-accepted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Offer Accepted
                        </span>
                        <span
                          style={
                            splitUrlValue === "offer-accepted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.offerAccepted}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "OFFER_REJECTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "offer-rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Offer Rejected
                        </span>
                        <span
                          style={
                            splitUrlValue === "offer-rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.offerRejected}]
                        </span>
                      </Link>
                    </li>
                  </ul>
                ) : null}
              </div>
            </div>
          </div>
        ))
      )}
      {/* <Pagination
        current={currentPage}
        pageSize={20}
        total={totalElements}
        onChange={onChange}
        className="HomePagination"
      /> */}
    </div>
  );
}
